/** Специальные виджеты  (Визуальные компоненты) для редактирования элементов (полей в карточке) DCAT каталога 
 * Параметрами является:
 * 1. uri - отображаемое свойства (predicate);
 * 2. value - начальное значение
 * 3. ...props - дополнительные параметры из которых формируются прараметры для Form.Item и вложенного Input
*/
import React from 'react';
import { Form, Input, DatePicker, InputNumber, Switch, Select } from 'antd';
import Label from './Label';
import moment from 'moment';

const { TextArea } = Input;
const { Option } = Select;

//
//Визуальные компоненты для ввода/редактирования полей в карточке DCAT каталога и его элементов
//

/**
 *  Компонент по умолчанию. Стандартный Input в оболочке Form.Item
 */
export const DefaultFormItem = ({uri, value, ...props}) => {
  const inputProps = {}
  const formItemProps = {};
  const { rules, hideLabel } = props;
  if (rules) formItemProps["rules"] = rules;
  const showLabel = (hideLabel)? false: true;
  //console.log("AssetInputs.js DefaultFormItem", uri, value, props);
  return (
    <Form.Item 
      name={uri} 
      label={showLabel && <Label iri={uri} />}
      initialValue={value} 
      {...formItemProps}
    >
      <Input {...inputProps}/>
    </Form.Item>
  )
}


/**
 *  Компонент для отображения даты. Стандартный DatePicker в оболочке Form.Item
 */
 export const DateFormItem = ({uri, value, ...props}) => {
  const inputProps = {}
  const formItemProps = {};
  const { rules, hideLabel } = props;
  if (rules) formItemProps["rules"] = rules;
  const showLabel = (hideLabel)? false: true;
  //console.log("AssetInputs.js DateFormItem", uri, value, props);
  //см. https://stackoverflow.com/questions/22184747/parse-string-to-date-with-moment-js
  const dateValue =  moment(value, "yyyy-MM-DD");
  const initialValue = dateValue.isValid()?dateValue:value;
  return (
    <Form.Item 
      name={uri} 
      label={showLabel && <Label iri={uri} />}
      initialValue={initialValue} 
      {...formItemProps}
    >
      {dateValue.isValid() ? 
        <DatePicker {...inputProps} />
      :
        <Input {...inputProps} />
      }
    </Form.Item>
  )
}


/**
 *  Компонент для отображения Числа. Стандартный DatePicker в оболочке Form.Item
 */
export const NumberFormItem = ({uri, value, ...props}) => {
  const inputProps = {}
  const formItemProps = {};
  const { rules, addonAfter, hideLabel} = props;
  if (rules) formItemProps["rules"] = rules;
  if (addonAfter) inputProps["addonAfter"] = addonAfter;
  const showLabel = (hideLabel)? false: true;
  return (
    <Form.Item 
      name={uri} 
      label={showLabel && <Label iri={uri} />}
      initialValue={value} 
      {...formItemProps}
    >
      <InputNumber {...inputProps} />
    </Form.Item>
  )
}

/**
 *  Компонент для отображения текстовых строк. Стандартный TextArea  в оболочке Form.Item
 */
 export const TextAreaFormItem = ({uri, value, ...props}) => {
  const inputProps = {}
  const { hideLabel} = props;
  const formItemProps = {};
  const showLabel = (hideLabel)? false: true;
  return (
    <Form.Item 
      name={uri} 
      label={showLabel && <Label iri={uri} />}
      initialValue={value} 
      {...formItemProps}
    >
      <TextArea {...inputProps} />
    </Form.Item>
  )
}

const AsIs =({label}) => { return label;};
/**
 *  Компонент для отображения текстовых строк. Стандартный Switch  в оболочке Form.Item
 */
export const SwitchFormItem = ({uri, value, ...props}) => {
  const inputProps = {};
  const { rules, hideLabel, label, defaultChecked} = props;
  const formItemProps = {};
  if (rules) formItemProps["rules"] = rules;
  const showLabel = (hideLabel)? false: true;
  const ShowLabelComponent = (label)? AsIs : Label;
  if (defaultChecked)
    inputProps["defaultChecked"] = true;
  const initialValue = (defaultChecked && value=="")?true: value;
  return (
    <Form.Item 
      name={uri} 
      label={showLabel && <ShowLabelComponent iri={uri} label={label}/>}
      initialValue={initialValue} 
      {...formItemProps}
    >
      <Switch {...inputProps} />
    </Form.Item>
  )
}

/**
 *  Компонент для отображения списк URI. Стандартный Select в оболочке Form.Item
 */
export const SelectUriFormItem = ({uri, value, ...props}) => {
  const inputProps = {};
  const { rules, hideLabel, label, placeholder, options, onSelect} = props;
  const formItemProps = {};
  if (rules) formItemProps["rules"] = rules;
  const showLabel = (hideLabel)? false: true;
  const ShowLabelComponent = (label)? AsIs : Label;
  if (placeholder)
    inputProps["placeholder"] = placeholder;
  if (onSelect)
    inputProps["onSelect"] = onSelect;
  //console.log("FormItemInputs.js SelectUriFormItem", inputProps, props);
  return (
    <Form.Item 
      name={uri} 
      label={showLabel && <ShowLabelComponent iri={uri} label={label}/>}
      initialValue={value} 
      {...formItemProps}
    >
      <Select {...inputProps}>
        <Option value={""}></Option>
        {options.map((item, i) => (
          <Option key={i} value={item}><Label iri={item}/> ({item})</Option>
        ))}
      </Select>
    </Form.Item>
  )
}
